import { RefinementListProvided } from 'react-instantsearch-core'

import Hit from 'components/Filters/types/Hit'
import { IconTickBox } from 'components/UI/Icons'
import Typography from 'components/UI/Typography/Typography'

import styles from './Checkbox.module.css'

type CheckboxProps = {
  item: Hit
  refine: RefinementListProvided['refine']
}

const Checkbox = ({ item, refine }: CheckboxProps): JSX.Element => {
  const { label, count, isRefined, value } = item

  return (
    <label htmlFor={label} className={styles.checkbox}>
      {isRefined && <IconTickBox className={styles.tickBox} />}
      <Typography.BodySmall theme="tertiaryDark">
        {label} ({count})
      </Typography.BodySmall>
      <input
        type="checkbox"
        id={label}
        name={label}
        checked={isRefined}
        className={styles.input}
        onChange={() => refine(value as string[])}
      />
    </label>
  )
}

export default Checkbox
